enum TooltipTrigger {
  HOVER = 'hover',
  ELLIPSIS = 'ellipsis',
}

export default TooltipTrigger;
